import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ExitIntentDialogComponent } from '@components/layout/exit-intent-dialog/exit-intent-dialog.component';
import { TranslateService } from '@ngx-translate/core';
import { CustomerIoAnalyticsService } from '@services/analytics/customerio-analytics.service';
import { EdeliveryService } from '@services/conditions/edelivery.service';
import { ExitIntentService } from '@services/exit-intent.service';
import { ApplicationFormService } from '@services/form/application-form.service';
import { StepsOrderBootstrapService } from '@services/steps-order-bootstrap.service';
import { ButtonModule } from 'primeng/button';

@Component({
    selector: 'isi-dtc-root',
    imports: [ButtonModule, RouterOutlet, ExitIntentDialogComponent],
    templateUrl: './app.component.html',
    styleUrl: './app.component.css',
})
export class App {
    private customerIoAnalytics = inject(CustomerIoAnalyticsService);
    private exitIntentService = inject(ExitIntentService);

    constructor(
        private translate: TranslateService,
        private applicationFormService: ApplicationFormService,
    ) {
        this.translate.addLangs(['en', 'es']);
        this.translate.setFallbackLang('en');
        this.translate.use('en');

        // Build the form BEFORE constructing the bootstrap service. Bootstrap injects
        // StepperService, whose constructor registers substep form groups against the
        // application form — so the form must exist first or the registry stays empty.
        this.applicationFormService.initForm();

        // Eagerly constructed so its order-resolution effect activates on app load.
        inject(StepsOrderBootstrapService);

        // Eagerly constructed so its enable/disable effects gate the e-delivery
        // controls app-wide, even on routes that never render them.
        inject(EdeliveryService);
    }
}
